
  function initStickyFilterBar() {
    // The default bar we watch for visibility.
    var ORIGINAL_TOGGLE_BAR_SELECTOR = '.facets-toggle';

    var bar = document.getElementById('sticky-filter-bar');
    var originalBar = document.querySelector(ORIGINAL_TOGGLE_BAR_SELECTOR);

    if (bar && originalBar) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('is-visible');
              bar.setAttribute('aria-hidden', 'true');
            } else {
              bar.classList.add('is-visible');
              bar.setAttribute('aria-hidden', 'false');
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(originalBar);
    } else if (bar) {
      // No original bar found (e.g. desktop, or theme markup changed):
      // keep the sticky bar out of the accessibility tree since it's
      // not being shown/toggled by the observer above.
      bar.setAttribute('aria-hidden', 'true');
    }

    var filterBtn = document.getElementById('stickyFilterBtn');
    var sortBtn = document.getElementById('stickySortBtn');

    if (filterBtn) {
      filterBtn.addEventListener('click', function () {
        document.body.classList.remove('drawer-mode-sort');
        document.body.classList.add('drawer-mode-filter');
      });
    }

    if (sortBtn) {
      sortBtn.addEventListener('click', function () {
        document.body.classList.remove('drawer-mode-filter');
        document.body.classList.add('drawer-mode-sort');
      });
    }

    // Reset mode when the drawer is closed, so opening it later from the
    // ORIGINAL default "Filter" bar shows everything again (not a
    // leftover filter-only/sort-only view).
    document.addEventListener('click', function (e) {
      var closeTrigger = e.target.closest('[on\\:click*="filters-drawer/close"], .facets_see-results, [aria-label="Close"]');
      if (closeTrigger) {
        document.body.classList.remove('drawer-mode-filter', 'drawer-mode-sort');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyFilterBar);
  } else {
    initStickyFilterBar();
  }
